<template>
  <v-container class="bg-primary pa-0"  fluid>
    
    <v-row class="d-flex align-items-center justify-center bg-secondary" style="margin:0 ; padding: 0;">
      <v-col class="pa-0">
        <v-card class="banner-card" :class="{ 'move-effect': isMoving }">
          <div class="banner-carousel">
            <!-- <v-img
              :key="images[currentIndex].image"
              :src="images[currentIndex].image"
              :alt="images[currentIndex].title"
              class="banner-image"
              contain
            /> -->
            <v-img
              :key="images[currentIndex].image"
              :src="images[currentIndex].image"
              :alt="images[currentIndex].title"
              class="banner-image"

              contain
            />
          </div>

          <!-- Dot Indicators -->
          <!-- <v-card-actions class="justify-center card-actions"> -->
            <div class="carousel-dots">
              <div
                v-for="(item, index) in images"
                :key="index"
                :class="['dot', { active: currentIndex === index }]"
                @click="setCurrentIndex(index)"
              ></div>
            </div>
          <!-- </v-card-actions> -->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import banner1 from "@/assets/images/landing/banner-1.png";
import banner2 from "@/assets/images/landing/banner-2.png";
// import banner3 from "@/assets/images/landing/banner-3.png";

// Define the images directly in the component
const images = [
  { title: 'Banner 1', image: banner1 },
  { title: 'Banner 2', image: banner2 },
  // { title: 'Banner 3', image: banner3 }
];

const currentIndex = ref(0);
const isMoving = ref(false);
let intervalId = null;
const delayTime = 300000;

// Function to go to the next image
const nextImage = () => {
  isMoving.value = true;
  currentIndex.value = (currentIndex.value + 1) % images.length;
  isMoving.value = false;
};

// Function to set the current index manually (for dot navigation)
const setCurrentIndex = (index) => {
  isMoving.value = true;
  currentIndex.value = index;
  isMoving.value = false;
};

// Automatically go to the next image at regular intervals
onMounted(() => {
  intervalId = setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % images.length; // Update index
  }, delayTime);
});

onBeforeUnmount(() => {
  if (intervalId) {
    clearInterval(intervalId); 
  }
});
</script>

<style scoped>
.v-theme--dark .v-card-text {
  background-color: #121212 !important;
  color: #ffffff !important;
}

.banner-card {
  position: relative;
  border-radius: 0px;
  overflow: hidden;
  border: none;

}

.banner-carousel {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: auto; 
  overflow: hidden;
}

.banner-image {
  width: 100%;
  /* max-height: 80vh;  */
  /* object-fit: cover; */
  transition: opacity 0.5s ease-in-out;
  /* border-radius: 8px;  */
}


.carousel-dots {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
}

.v-card--variant-elevated {
  box-shadow: none;
}

.dot {
  width: 13px;
  height: 13px;
  border-radius: 50%; 
  background: rgba(129, 131, 130, 0.822); 
  border: 2px solid #ffffff;
  cursor: pointer;
  opacity: 0.5; 
  transition: all 0.3s ease-in-out; 
  box-shadow: 0 0 5px rgba(211, 37, 75, 0.4); 
}


.dot:hover {
  background: rgba(211, 37, 75, 1); 
  transform: scale(1.3);
  opacity: 1;
  box-shadow: 0 0 10px rgba(211, 37, 75, 0.6);
}

.dot.active {
  background: rgba(124, 121, 122, 0.76);
  opacity: 1;
  transform: scale(1.2);
  box-shadow: 0 0 12px rgba(211, 37, 75, 0.8);
}

.card-actions {
  background-color: transparent;
  padding: 0;
}


/* Responsive Styles */
@media (max-width: 600px) {
  /* .banner-carousel {
    height: 200px; 
  } */

  .banner-image {
    object-fit: contain; 
  }
}

/* @media (max-width: 400px) {
  .banner-carousel {
    height: 180px;
  }
} */

/* @media (min-width: 601px) {
  .banner-carousel {
    height: 300px; 
  }

} */

/* @media (min-width: 319px) {

  .banner-card {
    margin: 0px -14px;
  }
} */
</style>
